import React from 'react';
import logo from '../assets/images/fqw_logo.png';
import {Row, Col} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {FooterBackground, CustomBrand, FooterMenu, StyledFooterContainer, CustomNavLink} from "../utils/footer-styles";

export const FooterLayout = () => {

    const navigate = useNavigate();

    function handleNavLinkClick(target) {
        navigate(target);
    }

    return (
        <FooterBackground>
            <StyledFooterContainer>
                <Row>
                    <Col xs={12} md={3}>
                        <CustomBrand>
                            <img src={logo} alt="The Friend's of Queen's Wood" width={200} height={200}/>
                        </CustomBrand>
                    </Col>
                    <Col xs={12} md={3}>
                        <FooterMenu>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/")}>Home</CustomNavLink></li>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/news/list")}>Latest News</CustomNavLink></li>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/events/list")}>Upcoming Events</CustomNavLink></li>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/articles/list")}>About the Wood</CustomNavLink></li>
                        </FooterMenu>
                    </Col>
                    <Col xs={12} md={3}>
                    <FooterMenu>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/static/about-the-friends")}>About the Friends</CustomNavLink></li>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/static/report-an-issue")}>Report an Issue</CustomNavLink></li>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/static/membership")}>Membership</CustomNavLink></li>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/static/volunteering")}>Volunteering</CustomNavLink></li>
                            <li><CustomNavLink onClick={(e) => handleNavLinkClick("/static/privacy-policy")}>Privacy Policy</CustomNavLink></li>
                        </FooterMenu>
                    </Col>
                    <Col xs={12} md={3}>
                        <FooterMenu>
                            <li><strong>Get in touch:</strong></li>
                            <li><CustomNavLink href="https://www.facebook.com/FriendsOfQueensWood/">Follow us on Facebook</CustomNavLink></li>
                            <li>&nbsp;</li>
                            <li>Email: <a href="mailto:info@fqw.org.uk">info@fqw.org.uk</a></li>
                        </FooterMenu>
                    </Col>
                </Row>
            </StyledFooterContainer>

        </FooterBackground>
    )
};
